module.exports = "//static.hsappstatic.net/react-codemirror/static-1.7986/theme/hubspot-canvas-dark.sass"